const ExpanIcon = ({ width = 12, height = 12 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.23999 5.35672L0.23999 6.63672L4.71999 6.63672L5.35999 5.99672L4.71999 5.35672L0.23999 5.35672Z"
        fill="black"
      />
      <path
        d="M5.35989 11.7578L6.63989 11.7578L6.63989 7.27781L5.99989 6.63781L5.35989 7.27781L5.35989 11.7578Z"
        fill="black"
      />
      <path
        d="M11.76 5.35672L11.76 6.63672L7.28001 6.63672L6.64001 5.99672L7.28001 5.35672L11.76 5.35672Z"
        fill="black"
      />
      <path
        d="M6.64011 0.238281L5.36011 0.238281L5.36011 4.71828L6.00011 5.35828L6.64011 4.71828L6.64011 0.238281Z"
        fill="black"
      />
    </svg>
  )
}

export default ExpanIcon
